module.exports = __webpack_public_path__ + "media/src/assets/Images/closedArrow-d5f1ab2f4c09decc965ce0d3636063ec.svg";